import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const Policy = lazy(() => import(/* webpackChunkName: "Policy" */ '../containers/Policy'));

export default () => {
  return <Route path="/contratacao" component={Policy} key="contratacao" />;
};
